// Define the interface for Product Category Information
export interface IProductCategoryInformation {
  productCategoryId ?: string; // Added for API response mapping
  scProductCategoryCode: string; // Dropdown field (required)
  scProductCategoryCodeDescription: string; // Description for scProductCategoryCode dropdown
  scProductCategoryUserSpecificTerm: string; // Text field (optional)
}

// Define the interface for API Response
export interface IProductCategoryResponse {
  scId: string;
  productCategoryId: string;
  scProductCategoryCode: string;
  scProductCategoryCodeDescription: string;
  scProductCategoryUserSpecificTerm: string;
}

export interface IProductCategoryApiResponse {
  response: IProductCategoryResponse[];
  no_of_records: number;
}

export const mapProductCategoryPayload = (jsonData: any, scId: string) => {
  return {
    scId: scId,
    productCategoryId: jsonData.productCategoryId ,
    scProductCategoryCode: jsonData.scProductCategoryCode,
    scProductCategoryCodeDescription: jsonData.scProductCategoryCodeDescription || "",
    scProductCategoryUserSpecificTerm: jsonData.scProductCategoryUserSpecificTerm || "",
  };
};

export const initialProductCategoryInformation: IProductCategoryInformation = {
  scProductCategoryCode: "",
  scProductCategoryCodeDescription: "",
  scProductCategoryUserSpecificTerm: "",
};

export const mapProductCategoryApiResponseToInitialValues = (response: any) => {
  return {
    productCategoryId : response?.productCategoryId || "",
    scProductCategoryCode: response?.scProductCategoryCode || "",
    scProductCategoryCodeDescription: response?.scProductCategoryCodeDescription || "",
    scProductCategoryUserSpecificTerm: response?.scProductCategoryUserSpecificTerm || "",
  };
};
